export enum ThenTypes {
  pivotFlowID = 'pivotFlowID',
  anonymousModule = 'anonymousModule',
  hidden = 'hidden',
}

export const thenOptions = [
  { label: 'Action', value: ThenTypes.anonymousModule },
  { label: 'Pivot', value: ThenTypes.pivotFlowID },
];
